import { readAttribution, submitWaitlist, validateSubmission } from './waitlist.mjs';

const attribution = readAttribution(window.location.search);
const form = document.querySelector('#waitlist-form');
const status = document.querySelector('#waitlist-status');
const submitButton = form?.querySelector('button[type="submit"]');

function setStatus(message, kind = '') {
  status.textContent = message;
  status.dataset.kind = kind;
}

form?.addEventListener('submit', async (event) => {
  event.preventDefault();
  const data = new FormData(form);
  const validation = validateSubmission({
    email: String(data.get('email') ?? ''),
    consent: data.get('consent') === 'on',
    website: String(data.get('website') ?? ''),
  });

  if (validation.kind === 'bot') {
    form.reset();
    setStatus('Du bist dabei. Wir melden uns zum Launch.', 'success');
    return;
  }
  if (validation.kind === 'invalid-email') {
    setStatus('Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
    form.elements.email.focus();
    return;
  }
  if (validation.kind === 'missing-consent') {
    setStatus('Bitte bestätige zuerst die Datenschutzerklärung.', 'error');
    form.elements.consent.focus();
    return;
  }

  submitButton.disabled = true;
  submitButton.textContent = 'Wird gesichert …';
  setStatus('');
  try {
    await submitWaitlist({
      email: validation.email,
      attribution,
      endpoint: import.meta.env.VITE_SUPABASE_URL,
      anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
    });
    form.reset();
    setStatus('Du bist dabei. Wir melden uns zum Launch.', 'success');
  } catch (error) {
    setStatus(error instanceof Error ? error.message : 'Das hat nicht geklappt. Bitte versuche es erneut.', 'error');
  } finally {
    submitButton.disabled = false;
    submitButton.textContent = 'Platz sichern';
  }
});

const revealItems = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.12 });
  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}
